import React, { memo, useMemo } from 'react'
import { Typography } from 'antd'
import {
  filter,
  groupBy,
  isEmpty,
  isNil,
  join,
  keys,
  map,
  reduce,
} from 'lodash'
import PropTypes from 'prop-types'

import { DISH_INGREDIENT_USED_FEATURE } from '../../constants'
import { dishIngredientPropType } from '../../prop-types'
import { StyledIngredientExplanationContainer } from '../styled'

const DishDetailsIngredientFeatures = ({ dishIngredients }) => {
  const ingredientsWithAlreadyFound = useMemo(
    () =>
      reduce(
        dishIngredients,
        (acc, ingredient) => [
          ...acc,
          ingredient,
          ...map(
            filter(
              ingredient.alreadyFoundIn,
              alreadyFoundIngredient =>
                !isNil(alreadyFoundIngredient.usedFeature),
            ),
            alreadyFoundIngredient => ({
              ...alreadyFoundIngredient,
              name: ingredient.name,
            }),
          ),
        ],
        [],
      ),
    [dishIngredients],
  )

  const ingredientsGroupedByUsedFeature = useMemo(
    () =>
      groupBy(
        filter(
          ingredientsWithAlreadyFound,
          ({ usedFeature }) =>
            !isNil(usedFeature) &&
            usedFeature !== DISH_INGREDIENT_USED_FEATURE.INGREDIENT_MATCHER,
        ),

        'usedFeature',
      ),
    [ingredientsWithAlreadyFound],
  )

  if (isEmpty(ingredientsGroupedByUsedFeature)) {
    return null
  }

  return (
    <>
      <Typography.Paragraph strong>
        Ingredient used features
      </Typography.Paragraph>
      {map(keys(ingredientsGroupedByUsedFeature), usedFeature => (
        <div key={usedFeature}>
          <StyledIngredientExplanationContainer>
            <Typography.Text>
              {`Suggested Ingredients based on ${usedFeature}:`}
            </Typography.Text>{' '}
            <Typography.Text>
              {join(
                map(
                  ingredientsGroupedByUsedFeature[usedFeature],
                  ({ ingredient }) => ingredient?.name,
                ),
                ', ',
              )}
            </Typography.Text>
          </StyledIngredientExplanationContainer>
        </div>
      ))}
    </>
  )
}

DishDetailsIngredientFeatures.propTypes = {
  dishIngredients: PropTypes.arrayOf(dishIngredientPropType).isRequired,
}

export default memo(DishDetailsIngredientFeatures)
